<app-header></app-header>
<app-menu></app-menu>
<div
  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
  style="top: 80px"
>
  <button
    mat-raised-button
    style="height: 30px !important; margin-top: 3vh !important"
    color="warning"
    class="col-md-1 InputSty"
    (click)="onNewInvoices()"
    type="button"
    *ngIf="viewListInvoice"
  >
    New Invoice
  </button>
  <div
    *ngIf="!viewListInvoice"
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
  >
    <div
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
    >
      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
        <mat-form-field
          appearance="fill"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <mat-label>Company name</mat-label>
          <mat-select
            [(value)]="valorCustomerMasivo"
            (selectionChange)="onChangedefault()"
            #cutstom
            [disabled]="readonlyType"
          >
            <mat-option *ngFor="let datos of Customer" [value]="datos.key">{{
              datos.value
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field
          appearance="fill"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <mat-label>Type</mat-label>
          <mat-select
            [(value)]="valorTYPE"
            [(ngModel)]="valorTYPE"
            [disabled]="readonlyType"
          >
            <mat-option value="RECEIVE-GENERAL">Receiving</mat-option>
            <mat-option value="CONTAINER-GENERAL">Container</mat-option>
            <mat-option *ngIf="false" value="SHIPPING-GENERAL"
              >Shipping</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field
          appearance="fill"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <mat-label>Type Rate</mat-label>
          <mat-select [(value)]="valorTYPERate" [disabled]="readonlyType">
            <mat-option value="1">1st-15th</mat-option>
            <mat-option value="2">16th-30th-31st</mat-option>
            <mat-option value="3">1st</mat-option>
            <mat-option value="4">Manuallity</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field color="accent" appearance="fill">
          <mat-label>From</mat-label>
          <input
            matInput
            [matDatepicker]="picker1"
            [(ngModel)]="From"
            [disabled]="readonlyType"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker1"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field color="accent" appearance="fill">
          <mat-label>To</mat-label>
          <input
            matInput
            [matDatepicker]="picker2"
            [(ngModel)]="To"
            [disabled]="readonlyType"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2 color="primary"></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div
      applytabindexes
      [formGroup]="FormInvoiceHeader"
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
    >
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field class="example-full-width">
          <mat-label>From name</mat-label>
          <input
            matInput
            formControlName="fromname"
            tabindex="1"
            class="TabOnEnterHeader"
          />
        </mat-form-field>
      </div>

      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field class="example-full-width">
          <mat-label>Address</mat-label>
          <input
            matInput
            formControlName="fromstreet"
            tabindex="2"
            class="TabOnEnterHeader"
          />
        </mat-form-field>
      </div>

      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field class="example-full-width">
          <mat-label>To name.</mat-label>
          <input
            matInput
            formControlName="toname"
            tabindex="3"
            class="TabOnEnterHeader"
          />
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field class="example-full-width">
          <mat-label>To street</mat-label>
          <input
            matInput
            formControlName="tostreet"
            tabindex="4"
            class="TabOnEnterHeader"
          />
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field class="example-full-width">
          <mat-label>Bill To.</mat-label>
          <input
            matInput
            formControlName="billname"
            tabindex="5"
            class="TabOnEnterHeader"
          />
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field class="example-full-width">
          <mat-label>Billing Address.</mat-label>
          <input
            matInput
            formControlName="billstreet"
            tabindex="6"
            class="TabOnEnterHeader"
          />
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field class="example-full-width">
          <mat-label>Invoice#</mat-label>
          <input
            matInput
            formControlName="invoicenumber"
            tabindex="7"
            class="TabOnEnterHeader"
            
          />
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field class="example-full-width">
          <mat-label>Payment Terms.</mat-label>
          <input
            matInput
            formControlName="payterm"
            tabindex="8"
            class="TabOnEnterHeader"
          />
        </mat-form-field>
      </div>
      <div
        *ngIf="false"
        class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
      >
        <mat-form-field class="example-full-width">
          <mat-label>Customer</mat-label>
          <input matInput formControlName="customerid" />
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field class="example-full-width">
          <mat-label>Reference#</mat-label>
          <input
            matInput
            formControlName="referencesnumber"
            tabindex="9"
            class="TabOnEnterHeader"
          />
        </mat-form-field>
      </div>
      <div
        class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 InputSty"
      >
        <mat-form-field color="accent" appearance="fill" class="InputSty">
          <mat-label>Date</mat-label>
          <input
            matInput
            [matDatepicker]="picker1DateInvoice"
            formControlName="dateinvoice"
            tabindex="10"
            class="TabOnEnterHeader"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker1DateInvoice"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker1DateInvoice></mat-datepicker>
        </mat-form-field>
      </div>
      <div
        *ngIf="false"
        class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
      >
        <mat-form-field class="example-full-width">
          <mat-label>Total amount</mat-label>
          <input matInput formControlName="totalamount" />
        </mat-form-field>
      </div>
      <div
        class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 InputSty"
      >
        <mat-form-field
          appearance="fill"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty"
        >
          <mat-label>Note</mat-label>
          <textarea
            matInput
            formControlName="noteinvoice"
            class="TabOnEnterHeader"
            tabindex="11"
          ></textarea>
        </mat-form-field>
      </div>
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 InputSty btn-group justify-content-center"
      >
        <button
          mat-raised-button
          style="height: 30px !important; margin-top: 3vh !important"
          color="primary"
          class="col-md-1 InputSty"
          (click)="oncleaar()"
          type="button"
        >
          Close
        </button>
       
        <button
          mat-raised-button
          style="height: 30px !important; margin-top: 3vh !important"
          color="warning"
          class="col-md-2 InputSty"
          (click)="oncleaar2()"
          type="button"
        >
          Clear and New invoice
        </button>
        <button
          mat-raised-button
          color="success"
          class="col-md-1 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="OnInvoiceHeaderInsert()"
          type="button"
        >
          {{ labelInvoiceHeaderButton }}
        </button>
        <button
          mat-raised-button
          color="primary"
          style="height: 30px !important; margin-top: 3vh !important"
          *ngIf="idorder != 0"
          class="col-md-1 InputSty"
          (click)="onviewsSearch()"
          type="button"
        >
          Search
        </button>
        <button
          mat-raised-button
          color="primary"
          style="height: 30px !important; margin-top: 3vh !important"
          *ngIf="idorder != 0"
          class="col-md-1 InputSty"
          (click)="onviewsAddCharges()"
          type="button"
        >
        Additional Charges
        </button>
        <button
          mat-raised-button
          color="danger"
          style="height: 30px !important; margin-top: 3vh !important"
          *ngIf="idorder != 0"
          class="col-md-1 InputSty"
          (click)="pdfGenerate()"
          type="button"
        >
          Generate pdf
        </button>

        <button
          mat-raised-button
          color="success"
          *ngIf="idorder != 0"
          class="col-md-1 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="onviewsexcelgenerar()"
          type="button"
        >
          Excel
        </button>
        <button
          mat-raised-button
          color="success"
          *ngIf="false"
          class="col-md-1 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="OnChangeDataInvoiceReceive()"
          type="button"
        >
          Rate Manuallity
        </button>
      </div>
    </div>
    <div
      style="border: 3px solid; border-color: rgb(243, 34, 44); margin-top: 3vh"
      *ngIf="invoiceSearchView"
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
    >
      <h1><b>SEARCH RECEIVER</b></h1>
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
      >
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field
            appearance="fill"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <mat-label>Type</mat-label>
            <mat-select [(value)]="valorTYPE2" [(ngModel)]="valorTYPE2">
              <mat-option value="RECEIVE-GENERAL">Receiving</mat-option>
              <mat-option value="CONTAINER-GENERAL">Container</mat-option>
              <mat-option *ngIf="false" value="SHIPPING-GENERAL"
                >Shipping</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div
          *ngIf="valorTYPE2 == 'RECEIVE-GENERAL'"
          class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
        >
          <mat-form-field
            appearance="fill"
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <mat-label>Company name</mat-label>
            <mat-select [(value)]="valorCustomerMasivo2" #cutstom2>
              <mat-option *ngFor="let datos of Customer" [value]="datos.key">{{
                datos.value
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field color="accent" appearance="fill">
            <mat-label>From</mat-label>
            <input
              matInput
              [matDatepicker]="picker1Search"
              [(ngModel)]="From2"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker1Search"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1Search></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
          <mat-form-field color="accent" appearance="fill">
            <mat-label>To</mat-label>
            <input matInput [matDatepicker]="picker2Search" [(ngModel)]="To2" />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker2Search"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker2Search color="primary"></mat-datepicker>
          </mat-form-field>
        </div>
        <button
          *ngIf="valorTYPE2 == 'RECEIVE-GENERAL'"
          mat-raised-button
          color="primary"
          class="col-md-2 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="OnChangeDataInvoiceReceiveSearch()"
        >
          Search
        </button>
        <button
          *ngIf="valorTYPE2 == 'CONTAINER-GENERAL'"
          mat-raised-button
          color="primary"
          class="col-md-2 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="OnChangeDataInvoiceContainerSearch()"
        >
          Search
        </button>
        <button
          *ngIf="valorTYPE2 == 'RECEIVE-GENERAL'"
          mat-raised-button
          color="success"
          class="col-md-2 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="exportAsExceltableSearchRece()"
        >
          Excel
        </button>
        <button
          *ngIf="valorTYPE2 == 'CONTAINER-GENERAL'"
          mat-raised-button
          color="success"
          class="col-md-2 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="exportAsExceltableSearchReceCon()"
        >
          Excel
        </button>
      </div>
      <div
        #tableSearchRece
        *ngIf="valorTYPE2 == 'RECEIVE-GENERAL'"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
      >
        <table class="table table-success table-striped-columns">
          <thead>
            <tr>
              <th>Options</th>
              <th>Receiver #</th>
              <th>Reference #</th>
              <th>Container #</th>
              <th>Received Date</th>
              <th>ETA</th>
              <th>Carrier</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of datosSearchReceiver">
              <td>
                <button
                  mat-raised-button
                  color="primary"
                  class="col-md-2 InputSty"
                  style="height: 30px !important; margin-top: 3vh !important"
                  (click)="onAddSearchRate(item)"
                >
                  Add
                </button>
              </td>
              <td>{{ item.ID }}</td>
              <td>{{ item.ReferenceNumber }}</td>
              <td>{{ item.ContainerNumber }}</td>
              <td>{{ item.ReceivedDate  }}</td>
              <td>{{ item.ETA }}</td>
              <td>{{ item.CarrierName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        #tableSearchReceCon
        *ngIf="valorTYPE2 == 'CONTAINER-GENERAL'"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
      >
        <table class="table table-success table-striped-columns">
          <thead>
            <tr>
              <th>Options</th>
              <th>Receiver #</th>
              <th>Customer</th>
              <th>Container #</th>
              <th>Reference #</th>
              <th>Arrived Date</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of containerList">
              <td>
                <button
                  mat-raised-button
                  color="primary"
                  class="col-md-2 InputSty"
                  style="height: 30px !important; margin-top: 3vh !important"
                  (click)="onselectReceiver(item.receivingID)"
                >
                  Add
                </button>
              </td>
              <td>{{ item.receivingID }}</td>
              <td>{{ item.Customer }}</td>

              <td>{{ item.ContainerNumber }}</td>
              <td>{{ item.ReferenceNumber }}</td>
              <td>{{ item.Arrived | date }}</td>
              <td>{{ item.QuantityP }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      *ngIf="invoiceexcelGenerar"
      style="border: 3px solid; border-color: rgb(2, 102, 7); margin-top: 3vh"
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
    >
      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
        <mat-form-field
          appearance="fill"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <mat-label>Company name</mat-label>
          <mat-select
            [(value)]="valorCustomerMasivo3"
            (selectionChange)="onChangedefault()"
            #cutstom
          >
            <mat-option *ngFor="let datos of Customer" [value]="datos.key">{{
              datos.value
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field
          appearance="fill"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <mat-label>Type</mat-label>
          <mat-select [(value)]="valorTYPE3" [(ngModel)]="valorTYPE3">
            <mat-option value="RECEIVE-GENERAL">Receiving</mat-option>
            <mat-option value="CONTAINER-GENERAL">Container</mat-option>
            <mat-option *ngIf="false" value="SHIPPING-GENERAL"
              >Shipping</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field
          appearance="fill"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <mat-label>Type Rate</mat-label>
          <mat-select [(value)]="valorTYPERate3" [(ngModel)]="valorTYPERate3">
            <mat-option value="1">1st-15th</mat-option>
            <mat-option value="2">16th-30th-31st</mat-option>
            <mat-option value="3">1st</mat-option>
            <mat-option value="4">Manuallity</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field color="accent" appearance="fill">
          <mat-label>From</mat-label>
          <input matInput [matDatepicker]="picker3" [(ngModel)]="From3" />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker3"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker3></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
        <mat-form-field color="accent" appearance="fill">
          <mat-label>To</mat-label>
          <input matInput [matDatepicker]="pickerex" [(ngModel)]="To3" />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerex"
          ></mat-datepicker-toggle>
          <mat-datepicker #pickerex color="primary"></mat-datepicker>
        </mat-form-field>
      </div>
      <button
        mat-raised-button
        color="primary"
        class="col-md-2 InputSty"
        style="height: 30px !important; margin-top: 3vh !important"
        (click)="ExportReceive()"
      >
        Generate Excel
      </button>
    </div>
    <div
      *ngIf="invoicechargesview"
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
      style="border: 3px solid; border-color: brown; margin-top: 3vh"
    >
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
        style="margin-top: 5vh"
        [formGroup]="FormReceivingChanges"
      >
        <h1
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <b>INVOICE CHARGES</b>
        </h1>
        <mat-form-field appearance="fill" class="col-md-2 InputSty">
          <mat-label>Receiving#</mat-label>
          <input
            matInput
            placeholder="Receiving#"
            formControlName="id"
            (change)="onChangeDa()"
            #rrr
          />
        </mat-form-field>

        <mat-form-field appearance="fill" class="col-md-5 InputSty">
          <mat-label>Charge Additional</mat-label>
          <mat-select
            formControlName="invoiceListSelect"
            (selectionChange)="OnCustomerChargesDesc($event)"
          >
            <mat-option *ngFor="let topping of invoiceList" [value]="topping">{{
              topping.value
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-md-2 InputSty">
          <mat-label>Unit price</mat-label>
          <input
            matInput
            placeholder="Unit price"
            formControlName="priceUnit"
            (change)="OnOperacion()"
          />
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-md-2 InputSty">
          <mat-label>Quantity</mat-label>
          <input
            matInput
            placeholder="Quantity"
            formControlName="QuantityChanges"
            (change)="OnOperacion()"
          />
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-md-2 InputSty">
          <mat-label>Total</mat-label>
          <input matInput placeholder="Total" formControlName="TotalChangesR" />
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-md-2 InputSty">
          <mat-label>Description</mat-label>
          <input matInput placeholder="Description" formControlName="extra1" />
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-md-2 InputSty">
          <mat-label>Aditional</mat-label>
          <input matInput placeholder="Aditional" formControlName="extra2" />
        </mat-form-field>
        <div class="col-md-6 btn-group">
          <button
            mat-raised-button
            color="danger"
            class="col-md-2 InputSty"
            style="height: 30px !important; margin-top: 3vh !important"
            (click)="OnClearReceivingCharges()"
          >
            Close charges
          </button>

          <button
            mat-raised-button
            color="primary"
            class="col-md-2 InputSty"
            style="height: 30px !important; margin-top: 3vh !important"
            (click)="OnNewChanges()"
          >
            {{ labelbuttonCharges }}
          </button>
        </div>
      </div>

      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
      >
        <table
          *ngIf="arrayDatosChangeReceivinng != null"
          class="table table-success table-striped-columns"
        >
          <thead>
            <tr>
              <th>Option</th>

              <th>Description</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of arrayDatosChangeReceivinng">
              <td>
                <button
                  mat-raised-button
                  color="primary"
                  style="height: 30px !important; margin-top: 3vh !important"
                  class="col-md-1 InputSty"
                  (click)="OnEditNewChanges(item)"
                >
                  Edit
                </button>
                <button
                  mat-raised-button
                  color="danger"
                  style="height: 30px !important; margin-top: 3vh !important"
                  class="col-md-1 InputSty"
                  (click)="OndeletechargesInvoice(item)"
                >
                  Delete
                </button>
              </td>

              <td>
                {{ item.tblInvoiceListDescription }} {{ item.extra1 }}
                {{ item.extra2 }}
              </td>
              <td>{{ item.UnitPrice }}</td>
              <td>{{ item.Quantity }}</td>
              <td>{{ item.Total }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <table class="table table-success table-striped-columns">
          <thead>
            <tr>
              <th>Options</th>
              <th>Invoice #</th>
              <th>Receiver #</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of receiverIDList">
              <td>
                <button
                  mat-raised-button
                  color="primary"
                  class="col-md-2 InputSty"
                  style="height: 30px !important; margin-top: 3vh !important"
                  (click)="OnReceiverIDInvoiceListDelete(item)"
                >
                  Delete
                </button>
                <button
                  mat-raised-button
                  color="success"
                  class="col-md-2 InputSty"
                  style="height: 30px !important; margin-top: 3vh !important"
                  (click)="onAddChargerInvoice(item.receiverID)"
                >
                  Add charges
                </button>
              </td>
              <td>{{ item.InvoiceId }}</td>
              <td>{{ item.receiverID }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      style="border: 3px solid; border-color: rgb(89, 42, 165); margin-top: 3vh"
      *ngIf="false"
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
    >
      <h1><b>INVOICE RECEIVING</b></h1>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <button
          mat-raised-button
          color="primary"
          class="col-md-2 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="onChangeDataInvoiceIetems()"
        >
          Save Rate
        </button>
        <button
          mat-raised-button
          color="success"
          class="col-md-2 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="exportAsExcelRate()"
        >
          export Rate
        </button>
      </div>
      <div
        *ngIf="datosExportInvoice != null"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        #excel2
      >
        <table class="table table-success table-striped-columns">
          <thead>
            <tr>
              <th>Total</th>
              <th>ReceiveID</th>

              <th>Item number</th>
              <th>Description</th>
              <th>Type</th>
              <th>Quantity</th>
              <th>rate amount</th>
              <th>Amount</th>
              <th>Carrier</th>
              <th>Reference</th>
              <th>po Number</th>
              <th>received Date</th>
            </tr>
          </thead>
          <tbody *ngFor="let item of datosExportInvoice.invoiceGeneralRequest">
            <tr
              *ngFor="
                let itemData of item.responseInvoiceItemsManuallity;
                let i = index
              "
            >
              <td>
                {{ itemData.totalPallets }}
              </td>
              <td>
                {{ itemData.tblReceivingProductsID }}
              </td>

              <td>{{ itemData.itemNumber }}</td>
              <td>{{ itemData.itemDescription }}</td>
              <td>{{ itemData.type_pallets }}</td>
              <td>{{ itemData.piecesByPallet }}</td>
              <td>
                <mat-form-field appearance="fill" class="col-md-4">
                  <mat-label>Enter your Rate</mat-label>
                  <input
                    matInput
                    placeholder="rate"
                    [(ngModel)]="itemData.rateamount"
                    type="number"
                  />
                </mat-form-field>
              </td>
              <td>{{ itemData.piecesByPallet * itemData.rateamount }}</td>
              <td>{{ item.responseReceiveDetail.carrierName }}</td>
              <td>{{ item.responseReceiveDetail.referenceNumber }}</td>
              <td>{{ item.responseReceiveDetail.poNumber }}</td>
              <td>{{ item.responseReceiveDetail.receivedDate | date }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      style="border: 3px solid; border-color: rgb(34, 243, 69); margin-top: 3vh"
      *ngIf="invoicerateAddview"
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
    >
      <h1><b>INVOICE ADD RECEIVER</b></h1>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <mat-form-field appearance="fill" class="col-md-2 InputSty">
          <mat-label>RECEIVER #</mat-label>
          <input
            matInput
            placeholder="RECEIVER #"
            [(ngModel)]="idorderAddReceiver"
          />
        </mat-form-field>
        <mat-form-field
          appearance="fill"
          class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
        >
          <mat-label>Type Rate</mat-label>
          <mat-select [(value)]="valorTYPERate2" [(ngModel)]="valorTYPERate2">
            <mat-option value="1">1st-15th</mat-option>
            <mat-option value="2">16th-30th-31st</mat-option>
            <mat-option value="3">1st</mat-option>
            <mat-option *ngIf="false" value="4">Manuallity</mat-option>
            <mat-option value="4">Customer Charges</mat-option>
          </mat-select>
        </mat-form-field>

        <button
          mat-raised-button
          color="warning"
          class="col-md-2 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="OnChangeDataInvoiceReceiveAddReceiver()"
        >
          Search receiver
        </button>
        <button
          mat-raised-button
          color="primary"
          class="col-md-1 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="OnSaveRateNew()"
        >
          Save Rate
        </button>
        <button
          mat-raised-button
          color="danger"
          class="col-md-2 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="onAddChargerInvoice(idorderAddReceiver)"
        >
          Add Charges #{{ idorderAddReceiver }}
        </button>
        <button
          mat-raised-button
          color="success"
          class="col-md-1 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="exportAsExcelRateReceiver()"
        >
          Excel
        </button>
        <button
          mat-raised-button
          color="danger"
          class="col-md-1 InputSty"
          style="height: 30px !important; margin-top: 3vh !important"
          (click)="onClearAddReceiver()"
        >
          Clear
        </button>
      </div>
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        #excelreceiverId
      >
        <button mat-mini-fab (click)="addLesson()">
          <mat-icon class="add-course-btn">add</mat-icon>
        </button>
        <br />
        <div class="add-lessons-form" [formGroup]="formArrayDataRate">
          <ng-container formArrayName="lessons">
            <ng-container
              *ngFor="let lessonForm of lessons.controls; let i = index"
            >
              <div class="lesson-form-row" [formGroup]="lessonForm">
                <mat-form-field
                  appearance="fill"
                  style="width: 80px !important"
                >
                  <mat-label>Pallet#</mat-label>
                  <input
                    matInput
                    formControlName="rowPosition"
                    placeholder="Pallet#"
                  />
                </mat-form-field>

                <mat-form-field
                  appearance="fill"
                  style="width: 200px !important"
                >
                  <mat-label>item number</mat-label>
                  <input
                    matInput
                    formControlName="itemNumber"
                    placeholder="Item Number"
                  />
                </mat-form-field>

                <mat-form-field
                  appearance="fill"
                  style="width: 200px !important"
                >
                  <mat-label>description</mat-label>
                  <input
                    matInput
                    formControlName="description"
                    placeholder="description"
                  />
                </mat-form-field>

                <mat-form-field
                  appearance="fill"
                  style="width: 100px !important"
                >
                  <mat-label>pallet</mat-label>
                  <input
                    matInput
                    formControlName="pallets"
                    placeholder="pallets"
                  />
                </mat-form-field>

                <mat-form-field
                  appearance="fill"
                  style="width: 100px !important"
                >
                  <mat-label>unit</mat-label>
                  <input
                    matInput
                    formControlName="type_pallets"
                    placeholder="Unit"
                  />
                </mat-form-field>

                <mat-form-field
                  appearance="fill"
                  style="width: 100px !important"
                >
                  <mat-label>Quantity</mat-label>
                  <input
                    matInput
                    formControlName="piecesByPallet"
                    placeholder="Quantity"
                  />
                </mat-form-field>

                <mat-form-field
                  appearance="fill"
                  style="width: 100px !important"
                >
                  <mat-label>rate</mat-label>
                  <input
                    matInput
                    formControlName="rateAmount"
                    placeholder="Rate"
                  />
                </mat-form-field>
                <mat-form-field
                  appearance="fill"
                  style="width: 100px !important"
                >
                  <mat-label>amount</mat-label>
                  <input
                    matInput
                    formControlName="amount"
                    placeholder="Amount"
                  />
                </mat-form-field>

                <mat-form-field
                  appearance="fill"
                  style="width: 100px !important"
                >
                  <mat-label>carrier</mat-label>
                  <input
                    matInput
                    formControlName="carrierName"
                    placeholder="carrierName"
                  />
                </mat-form-field>

                <mat-icon class="delete-btn" (click)="deleteLesson(i)">
                  delete_forever</mat-icon
                >
              </div>
            </ng-container>
          </ng-container>
        </div>

        <table *ngIf="false" class="table table-success table-striped-columns">
          <thead>
            <tr>
              <th>Pallet#</th>
              <th>Item Number</th>
              <th>Description</th>

              <th>Pallet</th>
              <th>Unit</th>
              <th>Quantity</th>
              <th>Rate</th>
              <th>Amount</th>
              <th>Carrier</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of RequestAddRateReceiverArray">
              <td>{{ item.rowPosition }}</td>
              <td>{{ item.itemNumber }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.pallets }}</td>
              <td>{{ item.type_pallets }}</td>
              <td>{{ item.piecesByPallet }}</td>
              <td>
                <mat-form-field appearance="fill" class="col-md-4 InputSty">
                  <mat-label>${{ item.rateAmount }}</mat-label>
                  <input
                    matInput
                    placeholder="Rate"
                    [(ngModel)]="item.rateAmount"
                  />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="fill" class="col-md-4 InputSty">
                  <mat-label>${{ item.amount }}</mat-label>
                  <input
                    matInput
                    placeholder="Amount"
                    [(ngModel)]="item.amount"
                  />
                </mat-form-field>
              </td>
              <td>{{ item.carrierName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      style="border: 3px solid; border-color: rgb(243, 34, 44); margin-top: 3vh"
      *ngIf="viewAddlistRate"
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
    >
      <h1><b>INVOICE RECEIVING</b></h1>
      <button
        mat-raised-button
        color="primary"
        class="col-md-2 InputSty"
        style="height: 30px !important; margin-top: 3vh !important"
        (click)="OnSaveRateNewUpdate()"
      >
        Update Rate
      </button>
      <div
        style="height: 70vh; overflow: auto"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
      >
        <table class="table table-success table-striped-columns">
          <thead>
            <tr>
              <th>Receiver #</th>
              <th>Pallet#</th>
              <th>Item Number</th>
              <th>Description</th>

              <th>Pallet</th>
              <th>Unit</th>
              <th>Quantity</th>
              <th>Rate</th>
              <th>Amount</th>
              <th>Carrier</th>
              <th>Reference #</th>
              <th>Container #</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of invoicecollectionrateamount">
              <td>{{ item.IDReceiving }}</td>
              <td>{{ item.rowPosition }}</td>
              <td>{{ item.ItemNumber }}</td>
              <td>{{ item.Description }}</td>
              <td>{{ item.Pallets }}</td>
              <td>{{ item.type_pallets }}</td>
              <td>{{ item.PiecesByPallet }}</td>
              <td>
                <mat-form-field appearance="fill" class="col-md-4 InputSty">
                  <mat-label>${{ item.rate_amount }}</mat-label>
                  <input
                    matInput
                    placeholder="Rate"
                    [(ngModel)]="item.rate_amount"
                  />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="fill" class="col-md-4 InputSty">
                  <mat-label>${{ item.amount }}</mat-label>
                  <input
                    matInput
                    placeholder="amount"
                    [(ngModel)]="item.amount"
                  />
                </mat-form-field>
              </td>
              <td>{{ item.CarrierName }}</td>
              <td>{{ item.ReferenceNumber }}</td>
              <td>{{ item.ContainerNumber }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div
    *ngIf="viewListInvoice"
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
    style="margin-top: 5vh; overflow-y: auto; height: 70vh"
  >
    <h1><b>Invoices</b></h1>
    <table class="table table-dark table-striped-columns">
      <thead>
        <tr>
          <th>Option</th>
          <th>Customer</th>
          <th>Type</th>
          <th>Invoice#</th>
          <th>Reference#</th>
          <th>From</th>
          <th>To</th>
          <th>Invoice Date</th>
          <th>Creation Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of invoiceheadergeneralSelect">
          <td>
            <button
              mat-raised-button
              color="danger"
              style="height: 30px !important; margin-top: 3vh !important"
              class="col-md-1 InputSty"
              (click)="onEditarInvoice(item)"
            >
              Edit
            </button>
          </td>
          <td>{{ item.company_name }}</td>
          <td>
            <p
              style="color: white !important"
              *ngIf="item.type_order == 'RECEIVE-GENERAL'"
            >
              <b>RECEIVING</b>
            </p>
            <p
              style="color: white !important"
              *ngIf="item.type_order == 'CONTAINER-GENERAL'"
            >
              <b>CONTAINER</b>
            </p>
            <p
              style="color: white !important"
              *ngIf="item.type_order == 'SHIPPING-GENERAL'"
            >
              <b>SHIPPING</b>
            </p>
          </td>

          <td>{{ item.invoicenumber }}</td>
          <td>{{ item.referencesnumber }}</td>
          <td>{{ item.fromdate }}</td>
          <td>{{ item.todate }}</td>
          <td>{{ item.dateinvoice }}</td>
          <td>{{ item.datecreate }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
></ngx-spinner>
